import classNames from 'classnames'

import { levels, colors, weights, styles, aligns } from '@/styles/shared/typography'

export type TextProps = {
  level: keyof typeof levels
  color?: keyof typeof colors
  weight?: keyof typeof weights
  align?: keyof typeof aligns
  children: React.ReactNode
  style?: keyof typeof styles
  className?: React.ComponentProps<'div'>['className'] | null
}

const Title = ({ level, color, weight, children, className }: TextProps) => {
  return (
    <h1 className={classNames(levels[level], color ? colors[color] : '', weight ? weights[weight] : '', className)}>
      {children}
    </h1>
  )
}

export default Title
